class DaySaveController {

    constructor($rootScope, $state, $stateParams, access, integrationService, currentPropertyService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
        this.integrationService = integrationService;
        this.currentProperty = currentPropertyService;
    }

    $onInit () {
        this.activeTab = this.$stateParams.tab || 'day';
    }

    canShow () {
        let integration = this.currentProperty.get('integration');
        return !!this.day.id && (this.access.check('manager') || (integration && integration.allow_time_constraining));
    }
}

DaySaveController.$inject = ['$rootScope', '$state', '$stateParams', 'access', 'integrationService', 'currentPropertyService'];

export default DaySaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/controllers/day.save.controller.js